import { z } from 'zod'

/** Shared by Vite's HTML transform and the app so both choose the same transport. */
export const analyticsEnvSchema = z.object({
  /** GTM takes precedence over direct GA4. Empty keeps the direct GA4 fallback. */
  VITE_GTM_CONTAINER_ID: z
    .string()
    .trim()
    .optional()
    .default('')
    .refine((v) => v === '' || /^GTM-[A-Z0-9]+$/.test(v), 'must be a GTM container ID (GTM-...)'),
  /** GA4 web stream ID. Empty disables analytics; never reuse the dev ID in prod. */
  VITE_GA4_MEASUREMENT_ID: z
    .string()
    .trim()
    .optional()
    .default('')
    .refine((v) => v === '' || /^G-[A-Z0-9]+$/.test(v), 'must be a GA4 ID (G-...)'),
  /** Opt-in DebugView only; normal traffic must not be marked as debug traffic. */
  VITE_GA4_DEBUG: z
    .string()
    .optional()
    .transform((v) => v?.trim().toLowerCase() === 'true' || v?.trim() === '1'),
})

export type AnalyticsEnv = z.infer<typeof analyticsEnvSchema>
